import {createSelector} from 'reselect'

export const selectSettlementProviderSearch = state => state.settlementProviderSearch || {}

export const selectSearchConfig = createSelector(selectSettlementProviderSearch,
    settlementProviderSearch => settlementProviderSearch.search_config
)

export const selectSearchConfigState = createSelector(selectSearchConfig,
    searchConfig => searchConfig && (searchConfig.origin_state || searchConfig.fallback_state)
)

export const selectSearchConfigOriginAddrOrZip = createSelector(selectSearchConfig,
    searchConfig => {
      if (searchConfig) {
        return (searchConfig.origin_address && searchConfig.origin_city && searchConfig.origin_state)
          ? `${searchConfig.origin_address} ${searchConfig.origin_city}, ${searchConfig.origin_state} ${searchConfig.origin_zipcode}`
          : searchConfig.origin_zipcode
      }
    }
)

export const selectSearchConfigIsPlaceOrderNowSupported = createSelector(selectSearchConfig,
    searchConfig => searchConfig && searchConfig.is_place_order_now_supported
)

export const selectSearchNameFilter = createSelector(selectSettlementProviderSearch,
    settlementProviderSearch => settlementProviderSearch.name_filter || ''
)

export const selectLastSearchTime = createSelector(selectSettlementProviderSearch,
    settlementProviderSearch => settlementProviderSearch.last_settlement_provider_search_time
)

export const selectSearchResults = createSelector(selectSettlementProviderSearch,
    settlementProviderSearch => settlementProviderSearch.search_results
)

export const selectSearchResultsPending = createSelector(selectSettlementProviderSearch,
    settlementProviderSearch => settlementProviderSearch.search_results_pending
)

export const selectPlaceOrderDefaults = createSelector(selectSettlementProviderSearch,
    settlementProviderSearch => settlementProviderSearch.place_order_defaults
)
